var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedWater(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.66 2.41352C12.28 2.08352 11.71 2.08352 11.33 2.41352C6.45 6.71352 4 10.4535 4 13.6335C4 18.6135 7.8 21.8335 12 21.8335C16.2 21.8335 20 18.6135 20 13.6335C20 10.4535 17.55 6.71352 12.66 2.41352ZM7.83 13.8335C8.2 13.8335 8.5 14.0935 8.57 14.4535C8.98 16.6735 10.85 17.4335 12.21 17.3235C12.64 17.3035 13 17.6435 13 18.0735C13 18.4735 12.68 18.8035 12.28 18.8235C10.15 18.9535 7.66 17.7335 7.09 14.7035C7.01 14.2535 7.37 13.8335 7.83 13.8335Z",
    fill: "#75748B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedWater);
export default __webpack_public_path__ + "static/media/Feed Water.edf3f8ee30a07c61f9617959aa6b20ad.svg";
export { ForwardRef as ReactComponent };